// App.js
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage from "./pages/HomePage";
import BusinessPage from "./pages/layout/BusinessPage";
import PreviewPage from "./pages/componenets/PreviewMode";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminPageEditor from "./pages/admin/AdminPageEditor";
import PrivacyPolicyPage from "./pages/privacy/PrivacyPolicyPage";
import ManagerPageEditor from "./pages/manager/ManagerPageEditor";
import RequireActivePage from "./routes/RequireActivePage";
import LoginPage from "./pages/LoginPage";
import { AuthProvider } from "./contexts/AuthContext";
import RoleRoute from "./routes/RoleRoute";
import Error404 from "./pages/Error404";
import PwaStartRedirect from "./pages/PwaStartRedirect";
import AdminLanguage from "./pages/admin/AdminLanguage";
function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Homepage />} />
          <Route path="/pwa-start" element={<PwaStartRedirect />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin/language" element={<AdminLanguage />} />
          {/* Admin only */}
          <Route
            path="/admin"
            element={
              <RoleRoute allow={["admin"]}>
                <AdminDashboard />
              </RoleRoute>
            }
          />
          <Route
            path="/admin/pages/:pageId"
            element={
              <RoleRoute allow={["admin"]}>
                <AdminPageEditor />
              </RoleRoute>
            }
          />
          <Route
            path="/admin/preview"
            element={
              <RoleRoute allow={["admin"]}>
                <PreviewPage />
              </RoleRoute>
            }
          />

          {/* Public business pages */}
          <Route
            path="/:slug"
            element={
              <RequireActivePage>
                <BusinessPage />
              </RequireActivePage>
            }
          />
          <Route
            path="/:slug/privacy"
            element={
              <RequireActivePage>
                <PrivacyPolicyPage />
              </RequireActivePage>
            }
          />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />

          {/* Manager only */}
          <Route
            path="/:slug/manager"
            element={
              <RoleRoute allow={["manager"]}>
                <ManagerPageEditor />
              </RoleRoute>
            }
          />

          {/* 404 – MUST BE LAST */}
          <Route path="*" element={<Error404 />} />

        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;